import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../../data/testimonials';
import { useEditorPreview } from '../../contexts/EditorContext';
import { Pending } from '../Pending';
export function Testimonials() {
  const editor = useEditorPreview();
  const hasReal = testimonials.length > 0;
  if (!hasReal && !editor) return null;
  const slots = hasReal ? testimonials : [0, 1, 2, 3, 4].map(() => null);
  return <section className="bg-white px-5 py-7" data-id="element-178" data-mp="y3ecbkuodd">
      <div className="mx-auto max-w-[580px]" data-id="element-179" data-mp="42jebs4jwskx">
        <h2 className="text-center font-display text-[21px] uppercase leading-[1.05] text-navy md:text-[24px]" data-id="element-180" data-mp="4187tkjq16q4">What diesel technicians are saying</h2>
        {!hasReal && <p className="mt-1.5 text-center" data-id="element-181" data-mp="dzxq3efj4t6w">
            <Pending label="Verified testimonials — hidden when published" data-id="element-182" data-mp="dymnvj1qfthw" />
          </p>}
        <ul className="mt-4 space-y-3.5" data-id="element-183" data-mp="2avlrjp2cx01d">
          {slots.map((t, i) => <li key={i} className={`rounded-[3px] border bg-white px-4 py-3 shadow-[0_1px_4px_rgba(16,24,32,0.08)] ${t ? 'border-line' : 'border-dashed border-line'}`} data-id="element-184" data-mp="2fsvm1j4ls1w2" data-mpi={i}>
              <div className="flex gap-0.5" aria-label={t ? `${t.rating} out of 5 stars` : undefined} aria-hidden={t ? undefined : true} data-id="element-185" data-mp="1nrpylm2fhn7t">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className={`h-3 w-3 ${t && s < t.rating ? 'fill-gold text-gold' : 'text-line'}`} aria-hidden="true" data-id="element-186" data-mp="1er1k6q94hkue" data-mpi={s} />)}
              </div>
              <blockquote className="mt-1.5 text-[11px] italic leading-[1.6] text-muted" data-id="element-187" data-mp="26llomkh2i1tr">
                {t ? `“${t.quote}”` : 'Testimonial slot — add a verified buyer review in the testimonials data.'}
              </blockquote>
              <div className="mt-2.5 flex items-center gap-2" data-id="element-188" data-mp="1xlyos33zl42t">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-gold font-display text-[10px] text-navy" data-id="element-189" data-mp="r4bijq0orsab">
                  {t ? t.name.charAt(0) : '?'}
                </span>
                <div data-id="element-190" data-mp="nmxj1po6ffan">
                  <p className="text-[9.5px] font-extrabold uppercase text-navy" data-id="element-191" data-mp="njjhukr91c4s">{t ? t.name : 'Name'}</p>
                  <p className="text-[8.5px] uppercase text-muted" data-id="element-192" data-mp="simlq1vhtcb6">{t ? t.role : 'Role · Workshop · Location'}</p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}